import React from 'react';
import PrimarySectionHeader from 'commonComponents/Headers/PrimarySectionHeader/PrimarySectionHeader';
import HorizontalTiles from 'commonComponents/HorizontalTiles/HorizontalTiles';
import LocationsPins from '../LocationsPins/LocationsPins';
import styles from './Organizations.module.scss';

/*eslint max-lines-per-function: ["error", 200]*/
const Organizations = ({
  data: {
    header,
    subheader,
    organizations,
    places
  },
  anchor,
  photos,
  logos,
  map
}) => { 
  const tilesData = [...organizations];

  tilesData.forEach((item, i) => {
    item.photo = photos[i];
    item.logo = logos[i];
  });

  const headerProps = {
    header,
    subheader,
    anchor
  };

  return ( 
    <section className={ styles.Organizations }>
      <div className={ styles.content }>
        <PrimarySectionHeader { ...headerProps } />
        <HorizontalTiles tilesData={ tilesData } />
        <div className={ styles.map }>
          <figure>
            <img src={ map } alt={ header } />
          </figure>
          <div className={ styles.places }>
            <LocationsPins list={ places } type="numeric" />
          </div>
        </div>
      </div>
    </section>
  );
};
 
export default Organizations;